import { render, staticRenderFns } from "./AdmittedPremiumTable.vue?vue&type=template&id=075c4d58&scoped=true&"
import script from "./AdmittedPremiumTable.vue?vue&type=script&lang=js&"
export * from "./AdmittedPremiumTable.vue?vue&type=script&lang=js&"
import style0 from "./AdmittedPremiumTable.vue?vue&type=style&index=0&id=075c4d58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075c4d58",
  null
  
)

export default component.exports